import { render, staticRenderFns } from "./Relates.vue?vue&type=template&id=386652b0&"
import script from "./Relates.vue?vue&type=script&lang=js&"
export * from "./Relates.vue?vue&type=script&lang=js&"
import style0 from "./Relates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports